/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2023. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Invoice, InvoiceItemCustomization } from '@core/models';

export class InvoiceItemCustomizationMultiAction {
  constructor(
    public items: InvoiceItemCustomization[] = [],
    public status = '',
    public billingPeriod = '',
    public invoice: Invoice | null = null,
    public deleteItems = false,
    public createInvoice = false
  ) {}
}
